import { tasksActionNames } from "./actions";

const initialState = {
  tasks: [
    /*
    {
      key: 0,
      title: "Create mockups",
      description: "use Figma",
      beingEdited: false,
      complete: true,
    },
    {
      key: 1,
      title: "Create app",
      description: "code front end using React",
      beingEdited: false,
      complete: false,
    },*/
  ],
};

export const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case tasksActionNames.ADD_TASK: {
      return {
        ...state,
        tasks: [...state.tasks, { ...action.payload, key: state.tasks.length }],
      };
    }
    case tasksActionNames.SET_COMPLETE: {
      return {
        ...state,
        tasks: state.tasks.map((task) => {
          if (task.key === action.payload.key) {
            return { ...task, complete: !task.complete };
          }
          return task;
        }),
      };
    }
    case tasksActionNames.TOGGLE_BEING_EDITED: {
      return {
        ...state,
        tasks: state.tasks.map((task) => {
          if (task.key === action.payload.key) {
            return {
              ...task,
              beingEdited: !task.beingEdited,
            };
          }
          return task;
        }),
      };
    }
    case tasksActionNames.EDIT_TASK: {
      return {
        ...state,
        tasks: state.tasks.map((task) => {
          if (task.key === action.payload.key) {
            return {
              ...task,
              title: action.payload.title,
              description: action.payload.description,
              beingEdited: !task.beingEdited,
            };
          }
          return task;
        }),
      };
    }
    default:
      return state;
  }
};
